import React from 'react';
import { IconProps } from './types';

const SimCardIcon = (props: IconProps) => {
  const { fillColor = '#00BA34' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask
        id="mask0_8167_64272"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8167_64272)">
        <path
          d="M4.66669 12.6693H6.00002V11.3359H4.66669V12.6693ZM4.66669 10.0026H6.00002V7.33594H4.66669V10.0026ZM7.33335 12.6693H8.66669V10.0026H7.33335V12.6693ZM7.33335 8.66927H8.66669V7.33594H7.33335V8.66927ZM10 12.6693H11.3334V11.3359H10V12.6693ZM10 10.0026H11.3334V7.33594H10V10.0026ZM4.00002 14.6693C3.63335 14.6693 3.31946 14.5387 3.05835 14.2776C2.79724 14.0165 2.66669 13.7026 2.66669 13.3359V5.33594L6.66669 1.33594H12C12.3667 1.33594 12.6806 1.46649 12.9417 1.7276C13.2028 1.98872 13.3334 2.3026 13.3334 2.66927V13.3359C13.3334 13.7026 13.2028 14.0165 12.9417 14.2776C12.6806 14.5387 12.3667 14.6693 12 14.6693H4.00002Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default SimCardIcon;
